<template lang="pug">
v-dialog(
  v-model="dialog",
  fullscreen,
  hide-overlay,
  transition="dialog-bottom-transition"
)
  template(v-slot:activator="{ on, attrs }")
      v-icon.mr-2(
      v-if="dialogType !== 'form'",
      slot="activator",
      small,
      title="View Detail",
      v-bind="attrs",
      v-on="on",
      @click="onDialogOpen"
      color="blue"
      :id="'loginActionPreviewPV_' + imItems.imNo"
    ) remove_red_eye

  v-card
    v-overlay(:value="overlay" absolute)
      v-progress-circular(indeterminate size="64")
    v-app-bar.navFixed(:color="themeColor", height="48px;")
      img.mr-2(
        :src="headerLogo",
        height="34",
        @click="$router.push('/')",
        style="cursor: pointer"
      )
      v-toolbar-title(
        style="cursor: pointer; font-size: 18px; font-weight: 600; color: white; display: flex; align-items: center;"
      ) i-Memo Preview 
      v-spacer
      v-toolbar-items
        v-btn(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)"
          dark
          text
          @click="approvalInfoDialog = true"
        )
          v-icon assignment_turned_in
          | &nbsp; Approval
        v-dialog(
          v-model="approvalInfoDialog"
          persistent
          max-width="420px"
        )
          v-card
            v-card-title(class="headline grey lighten-3 mb-3") Approval Form
            v-card-text
              div(style="display: flex; align-items: center; border: 1px solid #ccc; padding: 20px;")
                img(src="/img/icons/warning.png" width="50px" style="margin-right:1rem")
                p(style="font-size: 16px; color:black; margin: 0;")
                  | For approval, please use the link provided in the email or WhatsApp message. Thank you
            v-card-actions
              v-spacer
              v-btn(text color="primary" @click="approvalInfoDialog = false")
                | Close
        v-menu(offset-y v-if="imItems.imFileLampiran && imItems.imFileLampiran.length > 0")
          template(v-slot:activator="{ on, attrs }")
            v-btn(
              flat,
              dark,
              text,
              v-bind="attrs",
              v-on="on"
            )
              v-icon cloud_download
              | &nbsp; PV Attachments

          v-list
            v-list-item(
              v-for="(item, index) in imItems.imFileLampiran"
              :key="index"
            )
              v-list-item-title
                p(style="padding:1rem; margin:0")
                  a(@click="downloadFromUrl(item.url, item.base64)") {{ truncateText(item.name, 50) }}.{{extractExtension(item.url)}}
        
        v-menu(offset-y v-if="imItems.paymentRequest && imItems.paymentRequest.imFileLampiran && imItems.paymentRequest.imFileLampiran.length > 0")
          template(v-slot:activator="{ on, attrs }")
            v-btn(
              flat,
              dark,
              text,
              v-bind="attrs",
              v-on="on"
            )
              v-icon cloud_download
              | &nbsp; PR Attachments

          v-list
            v-list-item(
              v-for="(item, index) in imItems.paymentRequest.imFileLampiran"
              :key="index"
            )
              v-list-item-title
                p(style="padding:1rem; margin:0")
                  a(@click="downloadFromUrl(item.url, item.base64)") {{ truncateText(item.name, 50) }}.{{extractExtension(item.url)}}
        
        v-btn(
          dark,
          text,
          @click="printIM(imItems._id)"
        )
          v-icon print
          | &nbsp; Print
        
        v-btn(
          v-if="imItems.imStatus==4",
          dark,
          text,
          @click="openShareDialog"
        )
          v-icon share
          | &nbsp; Share
        
        v-dialog(v-model="share" persistent max-width="350px")
          v-card
            v-card-title(class="headline grey lighten-2") Share
            v-flex(class="text-center")
              ShareNetwork(
                v-for="network in networks"
                :key="network.network || network.key"
                :network="network.network"
                :title="shareNetworkTitle(network)"
                :url="shareNetworkUrl(network)"
                :description="shareNetworkDescription(network)"
              )
                img(:src="network.img" width="80px" style="margin:20px 15px;")
            v-spacer
            v-flex(class="text-right pa-4")
              v-btn(class="custom__padding-btn elevation-0" @click="share = false") Close
        
        v-btn(dark, text, @click.native="dialog = false")
          v-icon(title="Close") cancel
          | &nbsp;Close
    
    v-list.print-bg.padTop60(three-line, subheader)
      div(:id="imItems._id" style="height: 100%; min-height: 100vh;")
        // Small QR Code for Print (bottom right corner) - PV QR Code
        .qr-code-print(v-if="imItems.qrcode")
          img(
            :src="'data:image/png;base64, ' + imItems.qrcode"
            alt="QR Code"
          )

        .page(size="A4")
          table#header-view.view-width.print-header(style="margin-bottom: 1.2rem")
            tbody
              tr
                td.custom-td(
                  :style="`justify-content: ${dataPreview.logo_position}; display:flex`"
                  v-if="dataPreview.logo != ''"
                )
                  div(
                    style="display: flex; width: auto; flex-direction: column; align-items: center;"
                  )
                    img.height-60px(v-if="imItems.imUseLogo !== 'false' && imItems.imUseLogo !== false" :src="dataPreview.logo") 
                    p.logo-title(v-show="dataPreview.show_name" style="text-align:center") {{ dataPreview.bu_name }}
                    p.fw-300.tagline(v-show="dataPreview.show_tagline" style="text-align:center") {{ dataPreview.tagline }}

          .view-width(style="font-size: 14px")
            h2(style="text-align: center; padding: 5px") PAYMENT VOUCHER
            hr.custom-hr

            table.view-width(
              style="margin-top: 10px; width: 100%; border-collapse: collapse; font-size: 15px;"
            )
              tbody
                tr
                  td(
                    width="50%"
                    valign="top"
                    style="padding: 0.6rem 1rem;"
                  )
                    strong To
                    i.fw-300 &nbsp;Kepada
                    template(v-if="imItems.imWorkflow && imItems.imWorkflow.length")
                      ul.mt-n1(style="padding-top: 0.4rem;")
                        li(
                          v-for="(requestor, i) in imItems.imWorkflow.slice().reverse()"
                          :key="`pv-to-${i}`"
                          style="font-size: 15px"
                          v-if="requestor && requestor.status != 5 && (requestor.name || requestor.alias)"
                        )
                          span {{ imItems.imUseAlias ? requestor.alias : requestor.name }}
                    span(v-else style="font-size: 15px; display: inline-block; margin-top: 0.4rem;") -
                  td(width="50%" style="padding: 0;")
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong From
                        i.fw-300 &nbsp;Dari
                      br
                      span {{ formatActorName(imItems, imItems.imUser, false) }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Number
                        i.fw-300 &nbsp;Nomor
                      br
                      | {{ imItems.imNo }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Date
                        i.fw-300 &nbsp;Tanggal
                      br
                      | {{ getDocumentDate(imItems) }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Business Unit
                        i.fw-300 &nbsp;Unit Bisnis
                      br
                      | {{ getBusinessUnit(imItems) }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Subject
                        i.fw-300 &nbsp;Subjek
                      br
                      p(style="text-align: justify; margin: 0;") {{ imItems.imPerihal }}

            hr.custom-hr(style="margin-top: 2rem")
            div
              div(class="imPayBox" style="background: #F3F4F6; margin: 0.5rem 0;")
                strong(class="imPayTTL") Pay From
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Bayar Dari

              div(class="imPayBox")
                strong(class="imPayTTL") Bank Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.bankAccount && imItems.bankAccount.bank ? imItems.bankAccount.bank.name : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.bankAccount ? imItems.bankAccount.account_no : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Akun Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.bankAccount ? imItems.bankAccount.account_name : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Account Type
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Tipe Akun
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.bankAccount && imItems.bankAccount.account_type ? imItems.bankAccount.account_type : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Currency
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Mata Uang
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.bankAccount && imItems.bankAccount.currency ? imItems.bankAccount.currency : '-' }}

            hr.custom-hr(style="margin-top: 2rem")
            div(v-if="imItems.coaDetails && imItems.coaDetails.length > 0")
              table.view-width.no-split-table(
                border="1",
                class="coa-table",
                style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: left;"
              )
                tbody
                  tr(class="coa-head")
                    td(width="22%" style="padding-left: 1rem; text-align: center;")
                      b COA
                    td(width="22%" style="padding-left: 1rem; text-align: center;")
                      b Desc
                    td(width="12%" style="padding-left: 1rem; text-align: center;")
                      b Currency
                    td(width="22%" style="padding-left: 1rem; text-align: center;")
                      b Debit
                    td(width="22%" style="padding-left: 1rem; text-align: center;")
                      b Credit
                  tr(v-for="item in imItems.coaDetails" :key="item.coa_code")
                    td(width="22%" style="padding-left: 1rem; vertical-align: top;") {{ item.coa_name }}
                    td(width="22%" style="padding-left: 1rem; vertical-align: top; max-width: 200px; word-wrap: break-word; white-space: normal; text-align: left;") {{ item.description }}
                    td(width="12%" style="padding-left: 1rem; vertical-align: top;") {{ (imItems.imPaymentData && imItems.imPaymentData.paymentCurrency && imItems.imPaymentData.paymentCurrency.text) ? imItems.imPaymentData.paymentCurrency.text : '-' }}
                    td(width="22%" style="padding-left: 1rem; text-align: right; vertical-align: top;") {{ item.type && item.type.toLowerCase() === 'debit' ? formatCurrencyAmount(item.amount, (imItems.imPaymentData && imItems.imPaymentData.paymentCurrency && imItems.imPaymentData.paymentCurrency.text) ? imItems.imPaymentData.paymentCurrency.text : null) : '' }}
                    td(width="22%" style="padding-left: 1rem; text-align: right; vertical-align: top;") {{ item.type && item.type.toLowerCase() === 'credit' ? formatCurrencyAmount(item.amount, (imItems.imPaymentData && imItems.imPaymentData.paymentCurrency && imItems.imPaymentData.paymentCurrency.text) ? imItems.imPaymentData.paymentCurrency.text : null) : '' }}
              div(class="coa-notes")
                strong Notes
                i.fw-300 &nbsp;Catatan
                p(class="coa-notes-text") {{ imItems.notes ? stripHtml(imItems.notes) : '-' }}
              div(class="coa-disclaimer")
                strong Disclaimer
                i.fw-300 &nbsp;Disklaimer
                p Exchange rates are provided for reference only and are subject to market fluctuations. The actual amount payable in local currency will depend on the exchange rate applicable on the date of payment.
                p(style="margin-top: 1rem;")
                  i Nilai tukar hanya disediakan sebagai referensi dan dapat berubah mengikuti fluktuasi pasar. Jumlah yang harus dibayarkan dalam mata uang lokal akan bergantung pada kurs yang berlaku pada tanggal pembayaran.
            div(v-else)
              p(style="margin: 10px 0;") Data COA tidak tersedia.

            hr.custom-hr(style="margin-top: 2rem")
            // Move approval list to a new page for cleaner layout
            div(class="approval-section" style="page-break-before: auto; page-break-inside: avoid; padding-top: 0.5rem;")
              strong Approval list for
              i.fw-300 &nbsp;Daftar persetujuan untuk
              p(style="font-size: 14px") No. {{ imItems.imNo }}

              .view-width.detail-wrap(style="position: relative; font-size: 14px; height: auto")
                div(:class="['pv-watermark-preview', setWmPosition()]" v-if="wm.src != null")
                  img(:src="wm.src")

                div(id="background-pv" class="pv-watermark-preview" v-else)
                  div(v-if="matchesStatus(imItems, [1], ['draft'])")
                    img.imgWaterMark(src="img/draft.png")

                  div(v-if="matchesStatus(imItems, [2], ['on approval'])")
                    img.imgWaterMark-on-approval(src="img/on-approval.png")

                  div(v-if="matchesStatus(imItems, [4], ['fully approved', 'full approved'])")
                    img.imgWaterMark-fully-approved(src="img/fully-approved.png")

                  div(v-if="matchesStatus(imItems, [5], ['withdraw', 'user withdraw'])")
                    img.imgWaterMark(src="img/withdraw.png")

                  div(v-if="matchesStatus(imItems, [8], ['rejected'])")
                    img.imgWaterMark(src="img/rejected.png")

                table.view-width.approval-table.no-split-table(
                  border="1"
                  style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: center; z-index: 100"
                )
                  tbody
                    tr
                      td(colspan="3") 
                        b Submitted by
                        i.fw-300 &nbsp;Diajukan Oleh
                    tr(style="background: #f3f4f6")
                      td(width="36%") 
                        b Name
                          span(v-if="imItems.imHideTitle == false") &nbsp;& Position
                        br
                        i.fw-300 Nama
                          span(v-if="imItems.imHideTitle == false") &nbsp;& Jabatan
                      td(width="32%") 
                        b Comment
                        br
                        i.fw-300 Komentar
                      td(width="32%") 
                        b Digital Signature
                        br
                        i.fw-300 Tanda Tangan Digital
                    tr(height="80px")
                      td(width="40%" style="text-align:center; vertical-align: middle; padding-left: 1rem; padding-right: 1rem;")
                        b {{ formatActorNameForApproval(imItems, imItems.imUser) }}
                      td(style="vertical-align: middle;")
                        div(v-if="imItems.imStatus == 3 && imItems.imWorkflow && imItems.imWorkflow.length > 0 && imItems.imWorkflow[0].status == 6") Under Review
                        div(v-else) {{ getSubmitterComment(imItems) }}
                      td 
                        .approved(v-if="imItems.imStatus == 5")
                          img(:src="dataPreview.icon_withdraw" style="height: 30px;")
                          br
                          | {{ getSubmitterSignature(imItems) }}
                        .approved(v-else-if="imItems.imStatus == 1") &nbsp;
                        .approved(v-else-if="imItems.imStatus == 3 && imItems.imWorkflow && imItems.imWorkflow.length > 0 && imItems.imWorkflow[0].status == 6") {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                        .approved(v-else)
                          img(:src="dataPreview.icon_full_approve" style="height: 30px;")
                          br
                          | {{ getSubmitterSignature(imItems) }}
                    tr
                      td(colspan="3") 
                        b Approved by
                        i.fw-300 &nbsp;Disetujui Oleh
                    tr(style="background: #f3f4f6")
                      td(width="36%") 
                        b Name
                          span(v-if="imItems.imHideTitle == false") &nbsp;& Position
                        br
                        i.fw-300 Nama
                          span(v-if="imItems.imHideTitle == false") &nbsp;& Jabatan
                      td(width="32%") 
                        b Comment
                        br
                        i.fw-300 Komentar
                      td(width="32%")
                        b Digital Signature
                        br
                        i.fw-300 Tanda Tangan Digital
                    tr(v-if="getApproverWorkflows(imItems).length === 0")
                      td(colspan="3") -
                    tr(
                      v-for="(workflow, index) in getApproverWorkflows(imItems)"
                      :key="`pv-approver-${index}`"
                      height="80px"
                    )
                      td(width="40%" style="text-align:center; vertical-align: middle; padding-left: 1rem; padding-right: 1rem;")
                        b {{ formatActorNameForApproval(imItems, workflow) }}
                      td(style="vertical-align: middle;")
                        div(v-if="imItems.imStatus == 3 && workflow.status == 3") Under Review
                        div(v-else) {{ workflowComment(workflow) }}
                      td
                        .approved(v-if="workflow.status == 7")
                          img(:src="dataPreview.icon_full_approve" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="workflow.status == 8")
                          img(:src="dataPreview.icon_reject" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="workflow.status == 3")
                          img(:src="dataPreview.icon_withdraw" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="imItems.imStatus == 3 && workflow.date")
                          | {{ getTanggal(workflow.date) }}
                          br
                          | (Need Reapproval)
                        .approved(v-else-if="workflow.date")
                          | {{ getWorkflowSignature(workflow) }}
                        .approved.ff0000(v-else) &nbsp;

            div(style="text-align: center; margin-top: 1rem; margin-bottom: 1rem")
              div(style="font-size: 14px; font-weight: bold; color: red; text-align: center") QR code to validate the correctness of the information on the digital signature in this document.
              i.fw-300 Kode QR untuk memvalidasi kebenaran informasi pada tanda tangan digital dalam dokumen ini.
            p(style="text-align: center")
              img(
                v-if="imItems.qrcode"
                :src="'data:image/png;base64, ' + imItems.qrcode",
                style="vertical-align: middle; width: 150px"
              )
          div.qr-code-print(
            v-if="voucherQrCode"
            style="display: none;"
          )
            img(
              :src="'data:image/png;base64, ' + voucherQrCode",
              alt="Voucher QR Code"
            )


        .page.pagebreak(size="A4" v-if="imItems.paymentRequest")
          table#header-view.view-width.print-header(style="margin-bottom: 1.2rem")
            tbody
              tr
                td.custom-td(
                  :style="`justify-content: ${dataPreview.logo_position}; display:flex`"
                  v-if="dataPreview.logo != ''"
                )
                  div(
                    style="display: flex; width: auto; flex-direction: column; align-items: center;"
                  )
                    img.height-60px(v-if="imItems.imUseLogo !== 'false' && imItems.imUseLogo !== false" :src="dataPreview.logo") 
                    p.logo-title(v-show="dataPreview.show_name" style="text-align:center") {{ dataPreview.bu_name }}
                    p.fw-300.tagline(v-show="dataPreview.show_tagline" style="text-align:center") {{ dataPreview.tagline }}

          .view-width(style="font-size: 14px")
            h2(style="text-align: center; padding: 5px") PAYMENT REQUEST
            hr.custom-hr

            table.view-width(
              style="margin-top: 10px; width: 100%; border-collapse: collapse; font-size: 15px;"
            )
              tbody
                tr
                  td(
                    width="50%"
                    valign="top"
                    style="padding: 0.6rem 1rem;"
                  )
                    strong To
                    i.fw-300 &nbsp;Kepada
                    template(v-if="imItems.paymentRequest.imWorkflow && imItems.paymentRequest.imWorkflow.length")
                      ul.mt-n1(style="padding-top: 0.4rem;")
                        li(
                          v-for="(requestor, i) in imItems.paymentRequest.imWorkflow.slice().reverse()"
                          :key="`pr-to-${i}`"
                          style="font-size: 15px"
                          v-if="requestor.status != 5"
                        )
                          span {{ imItems.paymentRequest.imUseAlias ? requestor.alias : requestor.name }}
                    span(v-else style="font-size: 15px; display: inline-block; margin-top: 0.4rem;") -
                  td(width="50%" style="padding: 0;")
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong From
                        i.fw-300 &nbsp;Dari
                      br
                      span {{ formatActorName(imItems.paymentRequest, imItems.paymentRequest.imUser, false) }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Number
                        i.fw-300 &nbsp;Nomor
                      br
                      | {{ imItems.paymentRequest.imNo }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Date
                        i.fw-300 &nbsp;Tanggal
                      br
                      | {{ getDocumentDate(imItems.paymentRequest) }}
                    div(style="padding: 0.6rem 1rem 0.6rem 0; margin-left: 1rem; border-bottom: 1px solid #d1d5db;")
                      strong Subject
                        i.fw-300 &nbsp;Subjek
                      br
                      p(style="text-align: justify; margin: 0;") {{ imItems.paymentRequest.imPerihal }}
                tr
                  td(colspan="2" style="padding-left: 0.9rem; padding-top: 1rem;")
                    strong CC
                    i.fw-300 &nbsp;Tembusan
                    span &nbsp;{{ getCcDisplay(imItems.paymentRequest) }}

            hr.custom-hr(style="margin-top: 2rem")
            div
              div(class="imPayBox")
                strong(class="imPayTTL") Business Unit 
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Unit Bisnis
                strong : &nbsp;
                h5(class="imPayText") {{ getBusinessUnit(imItems.paymentRequest) }}
              div(class="imPayBox")
                strong(class="imPayTTL") Invoice No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Faktur
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataInvoiceNo ? imItems.paymentRequest.imPayDataInvoiceNo : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Invoice Date
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Tanggal Faktur
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataInvoiceDate ? imItems.paymentRequest.imPayDataInvoiceDate : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Tax No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Pajak
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataTaxNo ? imItems.paymentRequest.imPayDataTaxNo : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Purpose
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Tujuan
                strong : &nbsp;
                h5(class="imPayText") {{ stripHtml(imItems.paymentRequest.imTujuan) }}

              div(class="imPayBox" style="background: #F3F4F6; margin: 0.5rem 0;")
                strong(class="imPayTTL") Pay To
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Bayar Kepada

              div(class="imPayBox")
                strong(class="imPayTTL") Bank Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataBankName ? imItems.paymentRequest.imPayDataBankName : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataBankNo ? imItems.paymentRequest.imPayDataBankNo : '-' }}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Akun Bank
                strong : &nbsp;
                h5(class="imPayText") {{ imItems.paymentRequest.imPayDataPayTo ? imItems.paymentRequest.imPayDataPayTo : '-' }}

            hr.custom-hr(style="margin-top: 2rem")
            div(v-if="hasPaymentItems(imItems.paymentRequest)")
              strong Payment Details
              i.fw-300 &nbsp;Rincian Pembayaran
              table.view-width.no-split-table(
                border="1",
                style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: left;"
              )
                tbody 
                  tr(style="background: #f3f4f6")
                    td(width="50%" style="padding-left: 1rem;") 
                      b Items
                    td(width="50%" style="padding-left: 1rem;") 
                      b Amount
                  tr(
                    v-for="(item, index) in getPaymentItems(imItems.paymentRequest)"
                    :key="`pr-payment-item-${index}`"
                  )
                    td(width="50%" style="padding-left: 1rem;") {{ item.name }}
                    td(width="50%" style="padding-left: 1rem; text-align: right") {{ getMoneyFormat(item.amount) }}
                  tr(style="background: #f3f4f6")
                    td(width="50%" style="padding-left: 1rem;") 
                      b Total Amount
                    td(width="50%" style="padding-left: 1rem; text-align: right")
                      h4(style="margin:0;") {{ getMoneyFormat(getPaymentTotal(imItems.paymentRequest)) }}
            div(v-else)
              strong Payment Details
              i.fw-300 &nbsp;Rincian Pembayaran
              p(style="margin: 10px 0;") Data pembayaran tidak tersedia.

            hr.custom-hr(style="margin-top: 2rem")
            div(class="approval-section" style="page-break-before: auto; page-break-inside: avoid; padding-top: 0.5rem;")
              strong Approval list for
              i.fw-300 &nbsp;Daftar persetujuan untuk
              p(style="font-size: 14px") No. {{ imItems.paymentRequest.imNo }}

              .view-width.detail-wrap(style="position: relative; font-size: 14px; height: auto")
                div(:class="setWmPositionPR()" v-if="wmPR.src != null")
                  img(:src="wmPR.src")

                div(id="background-pr" v-else)
                  div(v-if="matchesStatus(imItems.paymentRequest, [1], ['draft'])")
                    img.imgWaterMark(src="img/draft.png")

                  div(v-if="matchesStatus(imItems.paymentRequest, [2], ['on approval'])")
                    img.imgWaterMark-on-approval(src="img/on-approval.png")

                  div(v-if="matchesStatus(imItems.paymentRequest, [4], ['fully approved', 'full approved'])")
                    img.imgWaterMark-fully-approved(src="img/fully-approved.png")

                  div(v-if="matchesStatus(imItems.paymentRequest, [5], ['withdraw', 'user withdraw'])")
                    img.imgWaterMark(src="img/withdraw.png")

                  div(v-if="matchesStatus(imItems.paymentRequest, [8], ['rejected'])")
                    img.imgWaterMark(src="img/rejected.png")

                table.view-width.approval-table.no-split-table(
                  border="1"
                  style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: center; z-index: 100"
                )
                  tbody
                    tr
                      td(colspan="3") 
                        b Submitted by
                        i.fw-300 &nbsp;Diajukan Oleh
                    tr(style="background: #f3f4f6")
                      td(width="36%") 
                        b Name
                          span(v-if="imItems.paymentRequest.imHideTitle == false") &nbsp;& Position
                        br
                        i.fw-300 Nama
                          span(v-if="imItems.paymentRequest.imHideTitle == false") &nbsp;& Jabatan
                      td(width="32%") 
                        b Comment
                        br
                        i.fw-300 Komentar
                      td(width="32%")
                        b Digital Signature
                        br
                        i.fw-300 Tanda Tangan Digital
                    tr(height="80px")
                      td(width="40%" style="text-align:center; vertical-align: middle; padding-left: 1rem; padding-right: 1rem;")
                        b {{ formatActorNameForApproval(imItems.paymentRequest, imItems.paymentRequest.imUser) }}
                      td(style="vertical-align: middle;")
                        div(v-if="imItems.paymentRequest.imStatus == 3 && imItems.paymentRequest.imWorkflow && imItems.paymentRequest.imWorkflow.length > 0 && imItems.paymentRequest.imWorkflow[0].status == 6") Under Review
                        div(v-else) {{ getSubmitterComment(imItems.paymentRequest) }}
                      td 
                        .approved(v-if="imItems.paymentRequest.imStatus == 5")
                          img(:src="dataPreview.icon_withdraw" style="height: 30px;")
                          br
                          | {{ getSubmitterSignature(imItems.paymentRequest) }}
                        .approved(v-else-if="imItems.paymentRequest.imStatus == 1") &nbsp;
                        .approved(v-else-if="imItems.paymentRequest.imStatus == 3 && imItems.paymentRequest.imWorkflow && imItems.paymentRequest.imWorkflow.length > 0 && imItems.paymentRequest.imWorkflow[0].status == 6") {{ imItems.paymentRequest.imDate ? getTanggal(imItems.paymentRequest.imDate) : '-' }}
                        .approved(v-else)
                          img(:src="dataPreview.icon_full_approve" style="height: 30px;")
                          br
                          | {{ getSubmitterSignature(imItems.paymentRequest) }}
                    tr
                      td(colspan="3") 
                        b Approved by
                        i.fw-300 &nbsp;Disetujui Oleh
                    tr(style="background: #f3f4f6")
                      td(width="36%") 
                        b Name
                          span(v-if="imItems.paymentRequest.imHideTitle == false") &nbsp;& Position
                        br
                        i.fw-300 Nama
                          span(v-if="imItems.paymentRequest.imHideTitle == false") &nbsp;& Jabatan
                      td(width="32%") 
                        b Comment
                        br
                        i.fw-300 Komentar
                      td(width="32%")
                        b Digital Signature
                        br
                        i.fw-300 Tanda Tangan Digital
                    tr(v-if="getApproverWorkflows(imItems.paymentRequest).length === 0")
                      td(colspan="3") -
                    tr(
                      v-for="(workflow, index) in getApproverWorkflows(imItems.paymentRequest)"
                      :key="`pr-approver-${index}`"
                      height="80px"
                    )
                      td(width="40%" style="text-align:center; vertical-align: middle; padding-left: 1rem; padding-right: 1rem;")
                        b {{ formatActorNameForApproval(imItems.paymentRequest, workflow) }}
                      td(style="vertical-align: middle;")
                        div(v-if="imItems.paymentRequest.imStatus == 3 && workflow.status == 3") Under Review
                        div(v-else) {{ workflowComment(workflow) }}
                      td
                        .approved(v-if="workflow.status == 7")
                          img(:src="dataPreview.icon_full_approve" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="workflow.status == 8")
                          img(:src="dataPreview.icon_reject" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="workflow.status == 3")
                          img(:src="dataPreview.icon_withdraw" style="height: 30px;")
                          br
                          | {{ getWorkflowSignature(workflow) }}
                        .approved(v-else-if="imItems.paymentRequest.imStatus == 3 && workflow.date")
                          | {{ getTanggal(workflow.date) }}
                          br
                          | (Need Reapproval)
                        .approved(v-else-if="workflow.date")
                          | {{ getWorkflowSignature(workflow) }}
                        .approved.ff0000(v-else) &nbsp;

            div(style="text-align: center; margin-top: 1rem; margin-bottom: 1rem")
              div(style="font-size: 14px; font-weight: bold; color: red; text-align: center") QR code to validate the correctness of the information on the digital signature in this document.
              i.fw-300 Kode QR untuk memvalidasi kebenaran informasi pada tanda tangan digital dalam dokumen ini.
            p(style="text-align: center")
              img(
                v-if="imItems.paymentRequest && imItems.paymentRequest.qrcode"
                :src="'data:image/png;base64, ' + imItems.paymentRequest.qrcode",
                style="vertical-align: middle; width: 150px"
              )

</template>

<script>
import axios from "axios";
import printJS from "print-js";
import defaultHeaderLogo from "@/assets/imemo-white.png";
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";

const ICON_FULL_APPROVE = require("../assets/check-64.png");
const ICON_REJECT = require("../assets/close-64.png");
const ICON_WITHDRAW = require("../assets/withdraw-64.png");

export default {
  name: "IMViewPV",
  props: {
    imItems: Object,
    dialogType: String,
    needReviewForUser: {
      type: Boolean,
      default: false,
    },
    needApprovalForUser: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    share: false,
    shareURL: "",
    overlay: false,
    approvalInfoDialog: false,
    i18n: i18n.default,
    dataPreview: {
      logo: "",
      logo_position: "center",
      bu_name: "",
      show_name: false,
      tagline: "",
      show_tagline: false,
      themeColor: "#D42A2A",
      headerLogo: defaultHeaderLogo,
      icon_full_approve: ICON_FULL_APPROVE,
      icon_reject: ICON_REJECT,
      icon_withdraw: ICON_WITHDRAW,
    },
    wm: {
      src: null,
      position: null,
      rotate: null,
      size: null,
    },
    wmPR: {
      src: null,
      position: null,
      rotate: null,
      size: null,
    },
  }),
  computed: {
    themeColor: function () {
      return this.dataPreview.themeColor || '#D42A2A';
    },
    headerLogo: function () {
      return this.dataPreview.headerLogo || defaultHeaderLogo;
    },
    voucherQrCode() {
      if (this.imItems && this.imItems.qrcode) {
        return this.imItems.qrcode;
      }
      if (
        this.imItems &&
        this.imItems.paymentRequest &&
        this.imItems.paymentRequest.qrcode
      ) {
        return this.imItems.paymentRequest.qrcode;
      }
      return null;
    },
    shareDescriptionSingleLine() {
      if (!this.sharing || !this.sharing.description) return "";
      return this.sharing.description.replace(/\s*\n\s*/g, " ").trim();
    },
    ...mapState(["sharing", "networks"]),
  },
  mounted() {
    this.refreshPreviewData();
  },
  watch: {
    "imItems._id": function () {
      this.refreshPreviewData();
    },
    dialog(newVal) {
      if (newVal) this.refreshPreviewData();
    },
  },
  methods: {
    getNormalizedStatusLabel(doc) {
      if (!doc) return "";
      const raw = doc.imStatusLabel || doc.status || "";
      return typeof raw === "string"
        ? raw.trim().toLowerCase()
        : String(raw).trim().toLowerCase();
    },
    matchesStatus(doc, codes = [], labels = []) {
      if (!doc) return false;
      const normalizedCode =
        doc.imStatus !== undefined && doc.imStatus !== null
          ? parseInt(doc.imStatus, 10)
          : null;
      const normalizedLabel = this.getNormalizedStatusLabel(doc);
      const hasCodeMatch =
        normalizedCode !== null && Array.isArray(codes)
          ? codes.includes(normalizedCode)
          : false;
      if (hasCodeMatch) return true;
      if (!Array.isArray(labels) || labels.length === 0 || !normalizedLabel)
        return false;
      return labels
        .map((label) =>
          typeof label === "string" ? label.trim().toLowerCase() : ""
        )
        .filter(Boolean)
        .includes(normalizedLabel);
    },
    isNeedApprovalStatus(item) {
      if (!item) return false;
      const label = (item.imStatusLabel || '').toLowerCase();
      if (label === 'need approval') return true;
      const statusCode = parseInt(item.imStatus, 10);
      if (statusCode === 9) return true;
      if (Array.isArray(item.imWorkflow)) {
        return item.imWorkflow.some((wf) => parseInt(wf.status, 10) === 9);
      }
      return false;
    },
    resolveNetworkType(network) {
      if (!network) return "";
      const value = network.network || network.key || "";
      return typeof value === "string" ? value.toLowerCase() : "";
    },
    shareNetworkTitle(network) {
      const type = this.resolveNetworkType(network);
      const baseTitle = (this.sharing && this.sharing.title) || "";
      return type === "whatsapp" ? `Subject: ${baseTitle}` : baseTitle;
    },
    shareNetworkUrl(network) {
      const type = this.resolveNetworkType(network);
      const shortUrl = (this.shareURL || "").trim();
      let bodyLine = "";
      if (shortUrl) {
        bodyLine = `Body: ${shortUrl}${this.shareDescriptionSingleLine ? ` ${this.shareDescriptionSingleLine}` : ""
          }`.trim();
      } else if (this.shareDescriptionSingleLine) {
        bodyLine = `Body: ${this.shareDescriptionSingleLine}`;
      }
      if (type === "whatsapp") {
        return bodyLine;
      }
      if (type === "email") {
        const subjectLine = (this.sharing && this.sharing.title) || "";
        const subjectPrefix = subjectLine ? `Subject: ${subjectLine}` : "";
        return [subjectPrefix, bodyLine].filter(Boolean).join(" ").trim();
      }
      return shortUrl;
    },
    shareNetworkDescription(network) {
      const type = this.resolveNetworkType(network);
      if (type === "whatsapp" || type === "email") return "";
      return (this.sharing && this.sharing.description) || "";
    },
    pickFieldValue(sources, field, defaultValue) {
      for (let i = 0; i < sources.length; i += 1) {
        const source = sources[i];
        if (source && Object.prototype.hasOwnProperty.call(source, field)) {
          return source[field];
        }
      }
      return defaultValue;
    },
    buildPreviewState(sourceBu, fallbackOrg, fallbackPaymentOrg) {
      const sources = [sourceBu, fallbackOrg, fallbackPaymentOrg].filter(Boolean);
      const pick = (field, defaultValue) =>
        this.pickFieldValue(sources, field, defaultValue);
      const settings =
        (sourceBu && sourceBu.settings) ||
        (fallbackOrg && fallbackOrg.settings) ||
        (fallbackPaymentOrg && fallbackPaymentOrg.settings) ||
        {};
      const headerLogoSettings = (settings && settings.headerLogo) || {};
      const logoAlignFromSettings =
        settings && settings.logo_align ? settings.logo_align : null;
      const showNameValue = pick("is_show_name", true);
      const showTaglineValue = pick("is_show_tagline", true);

      return {
        preview: {
          logo: pick("logo", ""),
          logo_position:
            logoAlignFromSettings || pick("logo_align", "center") || "center",
          bu_name: pick("name", ""),
          show_name: showNameValue !== false,
          tagline: pick("tagline", ""),
          show_tagline: showTaglineValue !== false,
          themeColor: (settings && settings.themeColors) || "#D42A2A",
          headerLogo:
            (headerLogoSettings && headerLogoSettings.src) || defaultHeaderLogo,
          icon_full_approve:
            (settings.approvalSignIcon && settings.approvalSignIcon.src) ||
            ICON_FULL_APPROVE,
          icon_reject:
            (settings.rejectionSignIcon && settings.rejectionSignIcon.src) ||
            ICON_REJECT,
          icon_withdraw:
            (settings.withdrawSignIcon && settings.withdrawSignIcon.src) ||
            ICON_WITHDRAW,
        },
        settings,
      };
    },
    updatePreviewFromLocalData(sourceBu = null) {
      const fallbackOrg =
        (this.imItems && this.imItems.imOrganization) || null;
      const paymentOrg =
        (this.imItems &&
          this.imItems.paymentRequest &&
          this.imItems.paymentRequest.imOrganization) ||
        null;
      const state = this.buildPreviewState(sourceBu, fallbackOrg, paymentOrg);
      this.dataPreview = state.preview;
      this.setWatermarks(state.settings);
    },
    setWatermarks(settings) {
      const effectiveSettings = settings || {};
      this.applyWatermarkForStatus(
        this.wm,
        this.imItems && this.imItems.imStatus,
        effectiveSettings
      );
      if (this.imItems && this.imItems.paymentRequest) {
        this.applyWatermarkForStatus(
          this.wmPR,
          this.imItems.paymentRequest.imStatus,
          effectiveSettings
        );
      }
    },
    applyWatermarkForStatus(target, status, settings) {
      if (!target) return;
      target.src = null;
      target.position = null;
      target.rotate = null;
      target.size = null;
      const normalized = parseInt(status, 10);
      const mapping = {
        1: settings && settings.draftWatermark,
        2: settings && settings.onApprovalWatermark,
        4: settings && settings.fullApprovedWatermark,
        5: settings && settings.withdrawWatermark,
        8: settings && settings.rejectedWatermark,
      };
      const config = mapping[normalized];
      if (config) {
        target.src = config.src;
        target.position = config.align;
        target.rotate = config.rotate;
        target.size = config.size;
      }
    },
    /* eslint-disable no-console */
    async onDialogOpen() {
      await this.refreshPreviewData();
    },
    refreshPreviewData() {
      if (!this.imItems || !this.imItems._id) return;
      // Use local data directly - no need for API call as data is already available in imItems
      this.updatePreviewFromLocalData();
      this.loadPaymentRequestDetail();
    },
    async loadPaymentRequestDetail() {
      console.log('[IMViewPV] loadPaymentRequestDetail() called');
      console.log('[IMViewPV] imItems:', this.imItems);
      console.log('[IMViewPV] imItems.paymentRequest:', this.imItems ? this.imItems.paymentRequest : 'imItems is null');

      try {
        if (!this.imItems) {
          console.log('[IMViewPV] No imItems');
          return;
        }

        if (!this.imItems.paymentRequest) {
          console.log('[IMViewPV] No paymentRequest in imItems');
          return;
        }

        // Handle case where paymentRequest might be just an ID string
        let paymentRequest = this.imItems.paymentRequest;
        if (typeof paymentRequest === 'string') {
          // If it's just a string ID, we need to load it
          paymentRequest = { id: paymentRequest };
          this.$set(this.imItems, 'paymentRequest', paymentRequest);
        }

        // Check if paymentRequest already has full details - need imWorkflow, imPerihal, and imUser
        const hasFullDetails =
          paymentRequest.imWorkflow &&
          Array.isArray(paymentRequest.imWorkflow) &&
          paymentRequest.imPerihal &&
          paymentRequest.imUser &&
          paymentRequest.imNo;

        if (hasFullDetails) {
          console.log('[IMViewPV] Payment Request details already loaded');
          return;
        }

        // Try to load by imNo first, then by id, then by _id
        const prIdentifier = paymentRequest.imNo || paymentRequest.id || paymentRequest._id;
        if (!prIdentifier) {
          console.warn('[IMViewPV] No payment request identifier found. paymentRequest:', paymentRequest);
          return;
        }

        console.log('[IMViewPV] Loading PR detail with identifier:', prIdentifier);

        const token = localStorage.getItem("token");
        const baseUrl =
          process.env.VUE_APP_API_OLD || process.env.VUE_APP_API;
        if (!baseUrl) return;
        const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get(
          `${baseUrl}/report/page-detail/${prIdentifier}`,
          config
        );

        const detail = response && response.data ? response.data : null;
        if (!detail) {
          console.warn('[IMViewPV] No payment request detail returned from API for:', prIdentifier);
          return;
        }

        console.log('[IMViewPV] Payment Request detail loaded successfully:', detail.imNo || detail._id);

        // Merge imPaymentData if available
        if (detail.imPaymentData) {
          this.$set(this.imItems, "imPaymentData", detail.imPaymentData);
        }

        // Merge the full PR data with existing paymentRequest data
        // Preserve the original id reference if it exists
        const originalId = paymentRequest.id || paymentRequest._id;
        const mergedPaymentRequest = Object.assign({}, paymentRequest, detail);

        // Ensure id is preserved from the original reference
        if (originalId && !mergedPaymentRequest.id) {
          mergedPaymentRequest.id = originalId;
        } else if (detail._id && !mergedPaymentRequest.id) {
          mergedPaymentRequest.id = detail._id;
        }

        // Ensure _id is set if not present
        if (!mergedPaymentRequest._id && detail._id) {
          mergedPaymentRequest._id = detail._id;
        }

        this.$set(this.imItems, "paymentRequest", mergedPaymentRequest);
        this.updatePreviewFromLocalData();
        console.log('[IMViewPV] Payment Request merged successfully:', mergedPaymentRequest.imNo);
      } catch (error) {
        console.error("[IMViewPV] Failed to load payment request details:", error);
        console.error("[IMViewPV] Error details:", error.response ? error.response.data : error.message);
        console.error("[IMViewPV] PR identifier was:", this.imItems.paymentRequest ? (this.imItems.paymentRequest.imNo || this.imItems.paymentRequest.id || this.imItems.paymentRequest._id) : 'N/A');
        // Don't throw error, just log it - the preview should still work without PR details
      }
    },
    /* eslint-enable no-console */
    printIM: function (id) {
      printJS({
        printable: id,
        type: "html",
        scanStyles: false,
        css: [
          "/stylesheets/vuetify.min.css",
          "/stylesheets/ck-content.css",
          "/stylesheets/approval-pv.css",
        ],
      });
    },
    getTanggal: function (tgl) {
      if (!tgl) return '-';
      let tanggal = new Date(tgl);
      let date = tanggal.getDate() < 10 ? "0" + tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString("default", { month: "short" });
      let hour = tanggal.getHours() < 10 ? "0" + tanggal.getHours() : tanggal.getHours();
      let minutes = tanggal.getMinutes() < 10 ? "0" + tanggal.getMinutes() : tanggal.getMinutes();
      return date + " " + month + " " + tanggal.getFullYear() + " " + hour + ":" + minutes;
    },
    getCurrencyConfig(currencyCode) {
      // Hardcoded currency configuration
      // IDR: 1.000.000 (titik sebagai pemisah ribuan, tidak ada desimal)
      // Non-IDR: 1,000.00 (koma sebagai pemisah ribuan, titik sebagai pemisah desimal)
      if (!currencyCode) return null;

      const upperCurrency = currencyCode.toUpperCase();
      
      if (upperCurrency === "IDR") {
        return {
          thousands: ".",
          decimal: "",
          precision: 0,
          suffix: " IDR",
        };
      } else {
        // Default untuk semua currency non-IDR (USD, EUR, SGD, dll)
        return {
          thousands: ",",
          decimal: ".",
          precision: 2,
          suffix: ` ${upperCurrency}`,
        };
      }
    },
    formatCurrency(amount, currencyCode, includeSuffix = true) {
      if (!currencyCode) {
        // Fallback to simple formatting if currencyCode not available
        if (amount === undefined || amount === null || amount === "") return "0";
        const numericAmount = typeof amount === "number" ? amount : Number(amount);
        if (Number.isNaN(numericAmount)) return "0";
        return new Intl.NumberFormat("id-ID").format(numericAmount);
      }

      const config = this.getCurrencyConfig(currencyCode);
      if (!config) {
        // Fallback
        if (amount === undefined || amount === null || amount === "") return "0";
        const numericAmount = typeof amount === "number" ? amount : Number(amount);
        if (Number.isNaN(numericAmount)) return "0";
        return new Intl.NumberFormat("id-ID").format(numericAmount);
      }

      // Convert to number and handle precision
      let value = parseFloat(amount);
      if (isNaN(value)) {
        return "0";
      }

      // Format to fixed precision
      let formatted = value.toFixed(config.precision);

      // Split number into integer and decimal parts
      let [integerPart, decimalPart] = formatted.split(".");

      // Add thousands separator
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, config.thousands);

      // Combine parts with appropriate decimal separator
      let result =
        decimalPart !== undefined && config.decimal
          ? `${integerPart}${config.decimal}${decimalPart}`
          : integerPart;

      // Add suffix only if includeSuffix is true
      return includeSuffix ? result + config.suffix : result;
    },
    formatCurrencyAmount(amount, currencyCode) {
      // Format currency without suffix (for COA table where currency is shown separately)
      return this.formatCurrency(amount, currencyCode, false);
    },
    getMoneyFormat: function (amount) {
      if (amount === undefined || amount === null || amount === "") return "0";

      // Get currency from payment request
      let currencyCode = null;
      if (
        this.imItems &&
        this.imItems.paymentRequest &&
        this.imItems.paymentRequest.imPaymentData &&
        this.imItems.paymentRequest.imPaymentData.paymentCurrency
      ) {
        currencyCode =
          this.imItems.paymentRequest.imPaymentData.paymentCurrency.text ||
          this.imItems.paymentRequest.imPaymentData.paymentCurrency.value;
      } else if (
        this.imItems &&
        this.imItems.imPaymentData &&
        this.imItems.imPaymentData.paymentCurrency
      ) {
        currencyCode =
          this.imItems.imPaymentData.paymentCurrency.text ||
          this.imItems.imPaymentData.paymentCurrency.value;
      }

      if (currencyCode) {
        return this.formatCurrency(amount, currencyCode);
      }

      // Fallback to simple formatting
      const numericAmount = typeof amount === "number" ? amount : Number(amount);
      if (Number.isNaN(numericAmount)) return "0";
      return new Intl.NumberFormat("id-ID").format(numericAmount);
    },
    getDocumentDate(doc) {
      if (!doc) return "-";
      if (doc.imReSubmitedDate) return this.getTanggal(doc.imReSubmitedDate);
      if (doc.imDate) return this.getTanggal(doc.imDate);
      return "-";
    },
    formatActorName(doc, actor, includePosition = true, ignoreHideTitle = false) {
      if (!actor) return "-";
      const useAlias = doc && doc.imUseAlias;
      const hideTitle = ignoreHideTitle ? false : (doc && doc.imHideTitle);
      const displayName = useAlias ? actor.alias || actor.name : actor.name || actor.alias;
      const position = !includePosition || hideTitle ? "" : actor.position ? ` / ${actor.position}` : "";
      return `${displayName || '-'}` + position;
    },
    formatActorNameForApproval(doc, actor) {
      if (!actor) return "-";
      const useAlias = doc && doc.imUseAlias;
      const hideTitle = doc && doc.imHideTitle;
      const displayName = useAlias ? actor.alias || actor.name : actor.name || actor.alias;
      const position = hideTitle ? "" : actor.position ? ` / ${actor.position}` : "";
      return `${displayName || '-'}` + position;
    },
    getBusinessUnit(doc) {
      if (!doc) return "-";
      const organization = doc.imOrganization || {};
      return organization.name || organization.bu_name || "-";
    },
    getCcDisplay(doc) {
      if (!doc || !Array.isArray(doc.imCC) || doc.imCC.length === 0) return "-";
      const useAlias = doc.imUseAlias;
      const names = doc.imCC
        .map((cc) => (useAlias ? cc.alias || cc.name : cc.name || cc.alias))
        .filter(Boolean);
      return names.length ? names.join(", ") : "-";
    },
    hasPaymentItems(doc) {
      return (
        doc &&
        doc.imPaymentData &&
        Array.isArray(doc.imPaymentData.paymentItems) &&
        doc.imPaymentData.paymentItems.length > 0
      );
    },
    getPaymentItems(doc) {
      return this.hasPaymentItems(doc) ? doc.imPaymentData.paymentItems : [];
    },
    getPaymentTotal(doc) {
      if (!doc || !doc.imPaymentData) return 0;
      return doc.imPaymentData.paymentTotal || 0;
    },
    getSubmitterSignature(doc) {
      const datePart = this.getDocumentDate(doc);
      const note = doc && doc.imStatus === 5 ? "(Withdrawn)" : "";
      if ((!datePart || datePart === "-") && !note) return "";
      return [datePart === "-" ? "" : datePart, note].filter(Boolean).join(" ").trim();
    },
    getSubmitterComment(_doc) {
      // Submitter comment is not used in PV; keep empty so it renders as blank
      return "";
    },
    getApproverWorkflows(doc) {
      if (!doc || !Array.isArray(doc.imWorkflow)) return [];
      return doc.imWorkflow.filter((workflow) => workflow && workflow.status !== 5);
    },
    workflowComment(workflow) {
      return workflow && workflow.comment ? workflow.comment : "";
    },
    getSignatureNote(status) {
      const notes = {
        3: "(Need Review)",
        5: "(Withdrawn)",
        6: "(Need Reapproval)",
        8: "(Rejected)",
        9: "(Need Reapproval)",
      };
      return notes[status] || "";
    },
    getWorkflowSignature(workflow) {
      if (!workflow) return "";
      const datePart = workflow.date ? this.getTanggal(workflow.date) : "";
      const note = this.getSignatureNote(workflow.status);
      if (!datePart && !note) return "";
      return [datePart, note].filter(Boolean).join(" ").trim();
    },
    stripHtml(value) {
      if (!value) return "-";
      return value
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/\s+/g, " ")
        .trim() || "-";
    },
    truncateText: function (text, maxLength) {
      if (!text) return "";
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength);
    },
    extractExtension: function (url) {
      if (!url) return "";
      const parts = url.split(".");
      return parts[parts.length - 1];
    },
    downloadFromUrl: function (url, base64) {
      if (base64) {
        const link = document.createElement("a");
        link.href = base64;
        link.download = url.split("/").pop();
        link.click();
      } else {
        window.open(url, "_blank");
      }
    },
    async openShareDialog() {
      this.overlay = true;
      try {
        let token = localStorage.getItem("token");
        const res = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_OLD}/gen-shareurl-pv/${this.imItems.imNo}`,
          headers: { Authorization: `Bearer ${token}` },
        });
        // The backend returns { url: "shortened_url" }
        this.shareURL = res.data.url;
        this.share = true;
      } catch (err) {
        const error = (err.response && err.response.data && err.response.data.message) || 'Error generating share URL';
        this.$toasted.error(error, { icon: "error" });
      } finally {
        this.overlay = false;
      }
    },
    copyShareURL() {
      navigator.clipboard.writeText(this.shareURL);
      this.$toasted.success('URL Copied to clipboard', { icon: 'check_circle' });
    },
    setWmPosition() {
      if (
        this.wm.position != null ||
        this.wm.rotate != null ||
        this.wm.size != null
      ) {
        let position =
          this.wm.position == "left"
            ? "img-wm__position-left"
            : this.wm.position == "center"
              ? "img-wm__position-center"
              : this.wm.position == "right"
                ? "img-wm__position-right"
                : "img-wm__position-default";

        let rotate = "";

        if (this.wm.rotate) {
          if (this.wm.position == "left") {
            rotate = "img-wm__rotate-90-left";
          } else if (this.wm.position == "center") {
            rotate = "img-wm__rotate-90-center";
          } else {
            rotate = "img-wm__rotate-90-right";
          }
        } else {
          rotate = "";
        }

        let size =
          this.wm.size == "large" ? "img-wm__size-xl" : "img-wm__size-l";

        return position + " " + rotate + " " + size;
      } else {
        return "img-wm__default";
      }
    },
    setWmPositionPR() {
      if (
        this.wmPR.position != null ||
        this.wmPR.rotate != null ||
        this.wmPR.size != null
      ) {
        let position =
          this.wmPR.position == "left"
            ? "img-wm__position-left"
            : this.wmPR.position == "center"
              ? "img-wm__position-center"
              : this.wmPR.position == "right"
                ? "img-wm__position-right"
                : "img-wm__position-default";

        let rotate = "";

        if (this.wmPR.rotate) {
          if (this.wmPR.position == "left") {
            rotate = "img-wm__rotate-90-left";
          } else if (this.wmPR.position == "center") {
            rotate = "img-wm__rotate-90-center";
          } else {
            rotate = "img-wm__rotate-90-right";
          }
        } else {
          rotate = "";
        }

        let size =
          this.wmPR.size == "large" ? "img-wm__size-xl" : "img-wm__size-l";

        return position + " " + rotate + " " + size;
      } else {
        return "img-wm__default";
      }
    },
  },
};
</script>

<style>
@import url("/stylesheets/approval-pv.css");
</style>
